// Expo Push is unsupported in this browser runtime. No native listeners/imports.
export function usePushNotifications(_uid?: string | null) {}
